import React, { useEffect, useState } from 'react'
import './Navbar.scss'
import { images } from '../../constants'
import { HiMenuAlt4, HiX } from 'react-icons/hi'
import { motion } from 'framer-motion';

const Navbar = () => {

    const [toggle, setToggle] = useState(false);
    const [active, setActive] = useState("home");
    const updateActiveFromHash = () => {
        const hash = window.location.hash.substring(1);
        setActive(hash || 'home');
    };

    useEffect(() => {
        updateActiveFromHash();
        window.addEventListener('hashchange', updateActiveFromHash);

        return () => {
            window.removeEventListener('hashchange', updateActiveFromHash);
        };
    }, []);

    return (
        <nav className="app__navbar">

            <div className="app__navbar-logo">
                <img src={images.logo} alt="logo" />
            </div>

            <ul className="app__navbar-links">
                {['home', 'about', 'work', 'skills', 'contact'].map((item) => (
                    <li key={`link-${item}`} className={`app__flex p-text `} onClick={() => setActive(`${item}`)}
                    >
                        <div />
                        <a href={`#${item}`} className={`${item === active && "activeNavLink"}`} >{item}</a>
                    </li>
                ))}
            </ul>

            <a href="/AseemGupta_Resume.pdf?v=4" download="AseemGupta_Resume.pdf" className="app__navbar__download">
                Resume
            </a>
            <div className="app__navbar-menu">
                <HiMenuAlt4 onClick={() => setToggle(prev => !prev)} />
                {
                    toggle && (
                        <motion.div initial={{ x: 300 }}
                            animate={{ x: 0 }}
                            exit={{ x: 300 }}
                            transition={{ duration: 0.5, ease: "easeOut" }}
                        >
                            <HiX onClick={() => setToggle(false)} />
                            <ul>
                                {['Resume', 'home', 'about', 'work', 'skills', 'contact'].map((item) => (
                                    <li key={item} >
                                        {item !== "Resume" ?
                                            <a href={`#${item}`} onClick={() => setToggle(false)} >{item}</a> :
                                            <a href="/AseemGupta_Resume.pdf?v=3" download="AseemGupta_Resume.pdf">
                                                Resume
                                            </a>
                                        }
                                    </li>
                                ))}

                            </ul>
                        </motion.div>
                    )
                }
            </div>
        </nav >
    )
}

export default Navbar